import { render, staticRenderFns } from "./CardParking.vue?vue&type=template&id=5518c560&"
import script from "./CardParking.vue?vue&type=script&lang=js&"
export * from "./CardParking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports